// removed by extract-text-webpack-plugin
module.exports = {"container":"tailor_container_3bkzV","lato-title":"tailor_lato-title_3KqEg lato-title"};


//////////////////
// WEBPACK FOOTER
// ./src/static/solution/tailor/tailor.css
// module id = 389
// module chunks = 4